import React from 'react';
import { AbsoluteCenter } from '../../../layout/AbsoluteCenter/AbsoluteCenter';
import { FlexCenter } from '../../../layout/FlexCenter/FlexCenter';
import { FullColor } from '../../../layout/FullColor/FullColor';
import { PanelLayout } from '../../../layout/Panel/Panel';
import { Spacing } from '../../../layout/Spacing/Spacing';
import { TextCustom } from '../../../ui/TextCustom';
import { Loader } from '../../Loader/Loader';
import { LoaderForModal } from '../../LoaderForModal/LoaderForModal';

interface IModalLoadingProps {
    label?: string;
    loaderSize?: number;
}

export const ModalLoading: React.FC<IModalLoadingProps> = ({ label = 'Provide label', loaderSize = 30 }) => {
    return (
        <FullColor>
            <AbsoluteCenter size={30} top={30}>
                <PanelLayout>
                    <LoaderForModal size={loaderSize} label={label} />
                </PanelLayout>
            </AbsoluteCenter>
        </FullColor>
    );
};
